import { ReactNode, useMemo } from 'react'
import { Key } from 'react-aria'
import { ObjectProperties } from '../../shared/types'
import { ObjectTypes, useObjectActionQuery } from '../api/object'
import { LOADING } from './loading'
import { Option, Select } from './select'

export function PluginInput({
	label,
	data,
	object,
	action,
	id,
	defaultValue,
	name,
	onChange,
	noDefault,
}: {
	label?: ReactNode
	data?: ObjectProperties
	object: keyof ObjectTypes
	action: string
	id: string
	defaultValue?: string
	name: string
	onChange?: (value: Key) => void
	noDefault?: true
}) {
	const { data: options = [], isLoading } = useObjectActionQuery<
		Array<Option & { isDefault?: boolean }>
	>(object, data?.[id] as string, action)

	const defaultOption = noDefault ? null : options.find(option => option.isDefault)

	const withEmpty = useMemo(() => {
		return [{ value: '', label: 'Vyberte' }, ...options]
	}, [options])

	if (isLoading) {
		return LOADING
	}

	return (
		<Select
			name={name}
			label={label}
			options={withEmpty}
			span="FULL"
			defaultSelectedKey={defaultOption?.value ?? defaultValue}
			onSelectionChange={onChange}
		/>
	)
}
